import { InvoicePage } from "./InvoicePage";
import { LinkedAccountsPage } from "./LinkedAccountsPage";
import { PortalOverviewPage } from "./PortalOverviewPage";
import { Link, Redirect, Route, Switch } from "wouter-preact";
import { useSiteConfig } from "../features/tenant/SiteConfigContext";
import { selectPortalCredentials } from "../features/auth/authSelectors";
import { routePaths, routes } from "../lib/route";
import { useAppSelector } from "../store/hooks";
import { PortalAccounts } from "../features/accounts/PortalAccounts";
import { PortalLayout } from "../components/PortalLayout";
import { AccountSwitcher } from "../features/accounts/AccountSwitcher";
import { usePortalAccounts } from "../features/accounts/usePortalAccounts";

export function PortalPage() {
  const { tenantId } = useSiteConfig();
  return <PortalSession key={tenantId} />;
}

function PortalSession() {
  const credentials = useAppSelector(selectPortalCredentials);
  if (credentials) return <PortalAccountRoutes />;

  const destination = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  return <Redirect to={`~${routes.signIn(destination)}`} replace />;
}

function PortalAccountRoutes() {
  const portalAccounts = usePortalAccounts();
  const accountProps = {
    viewState: portalAccounts.viewState,
    busy: portalAccounts.busy,
    onRetry: portalAccounts.retryAccounts,
    onSelect: portalAccounts.changeAccount,
  };

  return (
    <PortalLayout
      headerActions={
        <AccountSwitcher
          accounts={portalAccounts.accounts ?? []}
          currentCustomerId={portalAccounts.identity?.customerId ?? null}
          pending={portalAccounts.pending}
          onSelect={portalAccounts.changeAccount}
        />
      }
    >
      {portalAccounts.selectionError && (
        <p class="payment-error" role="alert">
          {portalAccounts.selectionError}
        </p>
      )}
      <Switch>
        <Route path={routePaths.portal.overview}>
          <PortalAccounts key={portalAccounts.scope} {...accountProps}>
            <PortalOverviewPage />
          </PortalAccounts>
        </Route>
        <Route path={routePaths.portal.invoice}>
          {(params) => (
            <PortalAccounts key={portalAccounts.scope} {...accountProps}>
              <InvoicePage key={params.invoiceCode} invoiceCode={params.invoiceCode} />
            </PortalAccounts>
          )}
        </Route>
        <Route path={routePaths.portal.linkedAccounts}>
          <LinkedAccountsPage key={portalAccounts.identity?.loginId} />
        </Route>
        <Route>
          <PortalNotFoundPage />
        </Route>
      </Switch>
    </PortalLayout>
  );
}

function PortalNotFoundPage() {
  return (
    <section class="empty-state">
      <h2>Page not found</h2>
      <p>We couldn't find this portal page.</p>
      <Link href="/">Back to overview</Link>
    </section>
  );
}
